<template>
  <module-list-layout :createAction="false" :module="module" v-if="amReady">
    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
      <moduleForm
          :autoBind="false"
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :formTitle="((editMode)? 'Update ' : 'Create ') + module.info.caption"
          :moduleDeleteAction='moduleFormDeleteAction'
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <div class="row pl-3 pr-3">
      <div class="col-12 col-md-6 pt-2">
        <dg-select-field
            :field_span="16"
            :label_span="24"
            :options="usersDropDownList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="userIdUpdated"
            field_mark="required"
            label="Users"
            name="user_id"
            rules="required"></dg-select-field>
        <!--<dg-text-field
            :field_span="19"
            :label_span="24"
            field_mark=""
            placeholder="search here"
            @amUpdated="userSearchUpdated"
            :liveUpdate="true"></dg-text-field>-->
      </div>
      <div class="col-12 col-md-6">
        <span style="display: inline-block;margin-right: 20px;">
              <el-tag type="success">Calls Counter: {{ recordsCounter }}</el-tag> <small>24 record per page</small>
            </span>
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
    </div>

    <div v-if="selectedUserId">
      Balance: ${{ userBalance }}
    </div>

    <el-table
        :data="rowData"
        border
        cell-class-name="p-1"
        style="width: 100%"
        v-if="selectedUserId">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
              :data="[props.row]"
              border
              cell-class-name="p-1"
              header-cell-class-name="app-light-silver-background p-1"
              style="width: 100%;">
            <el-table-column
                label="HungUpCause"
                prop="hung_up_cause">
            </el-table-column>
            <el-table-column
                label="Caller"
                prop="caller_id_name">
            </el-table-column>

          </el-table>

        </template>
      </el-table-column>
      <el-table-column
          label="IP"
          prop="free_switch_ip">
      </el-table-column>
      <el-table-column
          label="Destination"
          prop="caller_destination">
      </el-table-column>
      <el-table-column
          label="Direction"
          prop="direction">
      </el-table-column>
      <el-table-column
          label="Duration"
          prop="duration_in_seconds">
      </el-table-column>
      <el-table-column
          label="Answer"
          prop="answer_seconds"
          sortable>
      </el-table-column>
      <el-table-column
          label="Rate"
          prop="second_rate"
          sortable>
      </el-table-column>
      <el-table-column
          label="Total"
          prop="total_cost"
          sortable>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="deleteDialogVisible" center title="Warning" width="420px">
      <div align="center" class="mt-2 mb-2">You want to remove this record ?</div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="deleteDialogVisible = false" size="small">Cancel</el-button>
        <el-button @click="removeActionApi" size="small" type="danger">Yes</el-button>
      </span>
    </el-dialog>
  </module-list-layout>
</template>

<script>

import actionsCell from './ag-grid/ActionsCell'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'

import smartAgGridWrapper from "@/components/smart-input-view/AgGridWrapper";

export default {
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  data() {
    return {
      userBalance: '',
      usersDropDownList: [],
      rowData: [],
      deleteDialogVisible: false,
      targetParams: null,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 24,
      pageCount: 1,
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      selectedUserId: false
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getFormData()
  },
  methods: {
    userIdUpdated(inputField) {
      let value = inputField.field.field_value
      this.selectedUserId = value
      this.getEntityListData(1)
    },
    getFormData() {
      let promises = []
      promises.push(this.getUsersDropDownList({valueKey: 'id', profile: 12}).then((r) => {
        this.usersDropDownList = r
      }))
      Promise.all(promises).then((values) => {
        this.amReady = true
        $vue.nextTick(() => {
          this.bindController()
        })
      })
    },
    ...$mapActions('user-api', {getUsersDropDownList: 'getUsersDropDownList'}),
    updateField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.data.id,
        data
      }

      this.updateEntity(apiParams).then(r => {
        afterSave()
      })
    },
    getEntityListData(page) {
      this.getEntityList({page: page, search: this.userSearch, userId: this.selectedUserId}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.rowData = response.rows
      this.recordsCounter = response.count
      this.userBalance = response.balance
      this.amReady = true
    },
    userSearchUpdated(field) {
      // this.agGrid.gridApi.setQuickFilter(val);
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions(module.info.name + '-api', {getEntityList: 'list', updateEntity: 'update'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      $router.push({name: this.module.info.routeName + '->list->page', params: {listPage: page}})
      /*this.getEntityList({page: page, search: this.userSearch}).then(response => {
        this.buildAgGridData(response)
      })*/
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.rowData)
    },
    afterEdit(updatedData, propertyName = false, closeDialog = true) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      if (propertyName) {
        this.rowData[this.rowToEdit][propertyName] = updatedData;
      } else {
        this.rowData[this.rowToEdit] = updatedData;
      }

      if (closeDialog) this.dialogVisible = false;
      this.refreshGrid();
    },
    moduleFormDeleteAction() {
      this.removeAction({
        data: this.dataToBind,
        rowIndex: this.rowToEdit
      })
      this.dialogVisible = false;
    },
    afterCreate(newEntity) {
      this.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: this.module.info.routeName + '->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.targetParams = params
      this.deleteDialogVisible = true
    },
    removeActionApi() {
      let params = this.targetParams
      this.deleteDialogVisible = false
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
